import React from "react";

const OrganizationSchema: React.FC = () => {
  React.useEffect(() => {
    const schema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Spharaka Networks",
      "url": "https://spharaka.com",
      "logo": "https://spharaka.com/logo.png",
      "description": "Spharaka Networks delivers next-generation XDR powered by AuraXP to predict and stop threats before they impact your business.",
      "foundingDate": "2023",
      "industry": "Cybersecurity",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "IN"
      },
      "sameAs": [
        "https://linkedin.com/company/spharaka-networks",
        "https://twitter.com/spharakanetworks"
      ]
    };

    const scriptTag = document.createElement('script');
    scriptTag.type = 'application/ld+json';
    scriptTag.textContent = JSON.stringify(schema);
    document.head.appendChild(scriptTag);

    return () => {
      try {
        document.head.removeChild(scriptTag);
      } catch (e) {
        // Element may have already been removed
      }
    };
  }, []);

  return null; // This component only adds schema markup, no visual elements
};

export default OrganizationSchema;